import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from '../components/Loading';
import { useQuery } from "@tanstack/react-query";
import { getMyTest } from './apiTest';
import { createFetchErrorMessage } from "utils/api/ApiClient";
import moment from 'moment';

export const UserTestInfo = ()=>{
    const auth = useSelector(state => state.auth);
    const {data:myReadingTest, isLoading, isError, error} = useQuery({
        queryKey:['get-my-test'], 
        queryFn:getMyTest,
        staleTime:1000*60*60*30
    });


    if(!auth.authenticated) return <div className="no_data"><p>로그인 후 이용해주세요.</p></div>;
    if( null===auth.grade || null===auth.schoolClass || auth.grade===0 || auth.schoolClass===0 ){
        return (
            <div className="section pdT0">
                <p className="alignC orange"><i className="icon fas fa-exclamation-circle"></i> 독서력 진단을 하기 위해서는 ‘학년’  정보가 반드시 필요합니다. [마이페이지] – [변경] 메뉴를 이용해 ‘학년’ 정보를 입력해 주세요.</p>
            </div>
        );
    }
    
    if(isLoading) return <Loading />;
    if(isError) return <div className="no_data"><p>{createFetchErrorMessage(error).message}</p></div>;

    return (
        
            <div className="section">
                <div className="row test_btn_area">
                    <div className="col4 type1">
                        <div className="test_btn">
                            <Link to={`/${window.schoolCode}/reading/test/TEST1`} >
                                <p className="title type1"><strong>기본진단</strong><span>(30문항)</span></p>
                                <div className="icon icon01"></div>
                                <p className="text_btn"><strong className="arrow">진단하기</strong></p>
                            </Link>
                        </div>
                        { myReadingTest.data?.readingTest1!==null &&
                            [
                                <div className="badge" key="complete">완료</div>,
                                <p className="date" key="date">최근 진단일 : {moment(myReadingTest.data?.readingTest1Date).format("YYYY.MM.DD")}</p>
                            ]
                        }
                    </div>
                    <div className="col4 type2">
                        <div className="test_btn">
                            <Link to={`/${window.schoolCode}/reading/test/TEST2`} >
                                <p className="title type2"><strong>심화진단</strong><span>(15문항)</span></p>
                                <div className="icon icon02"></div>
                                <p className="text_btn"><strong className="arrow">진단하기</strong></p>
                            </Link>
                        </div>
                        { myReadingTest.data?.readingTest2!==null &&
                            [
                                <div className="badge" key="complete">완료</div>,
                                <p className="date" key="date">최근 진단일 : {moment(myReadingTest.data?.readingTest2Date).format("YYYY.MM.DD")}</p>
                            ]
                        }
                    </div>
                    <div className="col4 type3">
                        <div className="test_btn">
                            <Link to={`/${window.schoolCode}/reading/test/TEST3`} >
                                <p className="title type3"><strong>종합진단</strong><span>(기본+심화진단 45문항)</span></p>
                                <div className="icon icon03"></div>
                                <p className="text_btn"><strong className="arrow">진단하기</strong></p>
                            </Link>
                        </div>
                        { myReadingTest.data?.readingTest3!==null &&
                            [
                                <div className="badge" key="complete">완료</div>,
                                <p className="date" key="date">최근 진단일 : {moment(myReadingTest.data?.readingTest3Date).format("YYYY.MM.DD")}</p>
                            ]
                        }
                    </div>
                </div>

                { myReadingTest.data?.readingTest1!==null &&
                <div className="report_wrap type1">
                    <div className="title_area"><span className="date">{moment(myReadingTest.data?.readingTest1Date).format("YYYY.MM.DD")}</span><p className="title"><strong>기본진단 분석</strong></p></div>
                    <div className="cont_area">
                        <div className="cont_inner">
                            <div className="title_wrap"><div className="icon icon01"></div><strong>{myReadingTest.data?.readingTest1.name}</strong></div>
                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:myReadingTest.data?.readingTest1.description}}></div>
                        </div>
                    </div>
                </div>
                }

                { myReadingTest.data?.readingTest2!==null &&
                <div className="report_wrap type2">
                    <div className="title_area"><span className="date">{moment(myReadingTest.data?.readingTest2Date).format("YYYY.MM.DD")}</span><p className="title"><strong>심화진단 분석</strong></p></div>
                    <div className="cont_area">
                        <div className="cont_inner">
                            <div className="title_wrap"><div className="icon icon02"></div><strong>{myReadingTest.data?.readingTest2.name}</strong></div>
                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:myReadingTest.data?.readingTest2.description}}></div>
                        </div>
                    </div>
                </div>
                }

                {myReadingTest.data?.readingTest3!==null &&
                <div className="report_wrap type3">
                    <div className="title_area"><span className="date">{moment(myReadingTest.data?.readingTest3Date).format("YYYY.MM.DD")}</span><p className="title"><strong>종합진단 분석</strong></p></div>
                    <div className="cont_area">
                        {myReadingTest.data?.readingTest3_1!==null &&
                        <div className="cont_inner">
                            <div className="title_wrap"><div className="icon icon01"></div><span>기본진단 분석</span><strong className="arrow">{myReadingTest.data?.readingTest3_1.name}</strong></div>
                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:myReadingTest.data?.readingTest3_1.description}}></div>
                        </div>
                        }

                        {myReadingTest.data?.readingTest3_2!==null &&
                        <div className="cont_inner">
                            <div className="title_wrap"><div className="icon icon02"></div><span>심화진단 분석</span><strong className="arrow">{myReadingTest.data?.readingTest3_2.name}</strong></div>
                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:myReadingTest.data?.readingTest3_2.description}}></div>
                        </div>
                        }
                        <div className="cont_inner">
                            <div className="title_wrap"><div className="icon icon03"></div><span>종합진단 분석</span><strong className="arrow">{myReadingTest.data?.readingTest3.name}</strong></div>
                            <div className="bullet_list" dangerouslySetInnerHTML={{__html:myReadingTest.data?.readingTest3.description}}></div>
                        </div>
                    </div>
                </div>
                }


            </div>
        
    );
};